<template>
  <br/>
  <div style="padding:5px"  class="row">
    <div class="col-lg-4 mb-3">
        <label for="search" class="form-label mt-2 me-2">Search</label>
        <input id="search" class="form-control" placeholder="Name or email or id" v-model="keyword" @input="searchKeyword"/>
    </div>
    <div class="col-lg-4 mb-3">
      <label for="registration_date_from" class="form-label mt-2 me-2">Registration from</label>
      <input type="datetime-local" id="registration_date_from" class="form-control" v-model="registration_date_from" @change="searchKeyword"/>
    </div>
    <div class="col-lg-4 mb-3">
      <label for="registration_date_to" class="form-label mt-2 me-2">Registration to</label>
      <input type="datetime-local" id="registration_date_to" class="form-control" v-model="registration_date_to" @change="searchKeyword"/>
    </div>
    <div class="col-lg-4 mb-3">
      <label for="users-country-filter" class="form-label mt-2 me-2">Country</label>
      <select
        id="users-country-filter"
        class="form-control"
        v-model="countryFilter"
        @change="onCountryFilterChange"
      >
        <option value="">All</option>
        <option
          v-for="c in countries"
          :key="c.value"
          :value="c.value"
        >
          {{ formatCountryOptionLabel(c) }}
        </option>
      </select>
    </div>
    <div class="col-lg-4 mb-3">
      <label for="is_subscribed" class="form-label mt-2 me-2">Is newsletter subscribed</label>
      <select id="is_subscribed" class="form-control" v-model="is_news_letter_subscribed" @change="searchKeyword">
        <option :value="null">All</option>
        <option :value="true">Yes</option>
        <option :value="false">No</option>
      </select>
    </div>
    <div class="col-lg-4 mb-3">
      <label for="per-page" class="form-label me-2 mt-2">Per page</label>
      <select id="per-page" class="form-control" v-model="perPage" @change="perPageFilter(perPage)">
        <option :value="10">10</option>
        <option :value="20">20</option>
        <option :value="50">50</option>
      </select>
      </div>
  </div>

  <div style="padding:5px" class="row">
      <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
        <button :disabled="disableExport" @click="confirmExport()" type="button" class="btn btn-success text-white">
            <span v-if="!disableExport">Export CSV</span>
            <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
        </button>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 mb-3 d-flex align-items-end">
        <button type="button" class="btn btn-secondary" @click="resetFilters">
          Reset filters
        </button>
      </div>
  </div>

<div class="table-responsive container-fluid d-grid gap-3">
<table class="table">
  <thead>
  <tr>
    <th scope="col"># ID</th>
    <th scope="col">Full name</th>
    <th scope="col">E-mail</th>
    <th scope="col">Country</th>
    <th scope="col">Registered at</th>
    <th scope="col">Email verified at</th>
    <th scope="col">Social Link</th>
    <th scope="col">Actions</th>
  </tr>
  </thead>
  <tbody>
  <tr v-if="loading">
    <td colspan="8" class="text-center"><font-awesome-icon icon="fa-solid fa-sync" spin/></td>
  </tr>
  <tr v-else-if="users.length > 0" v-for="user in users" :key="user.id">
    <th scope="row">{{user.id}}</th>
    <td><router-link :to="{name: 'SingleUser', params: {id: user.id }}">{{user.name}}</router-link></td>
    <td>{{user.email}}</td>
    <td>{{ formatAdminUserCountryCell(user.country) }}</td>
    <td>{{user.created_at}}</td>
    <td>{{user.email_verified_at}}</td>
    <td>
      <a
          v-if="user.facebook_provider_id !== 'null'"
          :target="'_blank'"
          :href="'https://www.facebook.com/' + user.facebook_provider_id"
      >
        https://www.facebook.com/{{ user.facebook_provider_id }}
      </a>
      <br>
      <a
          v-if="user.google_provider_id !== 'null'"
          :href="'mailto:' + user.email"
      >
        {{ user.email }}
      </a>
      <br>
      <a
          v-if="user.linkedin_provider_id !== 'null'"
          :target="'_blank'"
          :href="'https://www.linkedin.com/in/' + user.linkedin_provider_id"
      >
        https://www.linkedin.com/in/{{ user.linkedin_provider_id }}
      </a>
    </td>
    <td>
      <router-link :class="{disabled: !approvedRoles.includes(role)}" :to="{name: 'EditUser', params: {id: user.id }}" class="btn btn-warning">
        Edit
      </router-link>
    </td>
  </tr>
  <tr v-else>
    <td colspan="8" class="text-center">No users</td>
  </tr>
  </tbody>
</table>
  <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
    <div>
      <div class="p-2">
        <p>Total users: {{ totalRecords }}</p>
      </div>
    </div>
    <div>
      <div class="p-2">
        <nav v-if="totalPages >= 1" aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
              <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
            </li>
            <li class="page-item" :class="{active: 1 === currentPage}">
              <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
            </li>
            <li v-if="currentPage - 2 > 1" class="page-item">
              <a href="#" class="page-link">...</a>
            </li>
            <li class="page-item" v-if="currentPage - 2 > 1">
              <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2}}</a>
            </li>
            <li class="page-item" v-if="currentPage - 1 > 1">
              <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1}}</a>
            </li>
            <li class="page-item" v-if="currentPage !== 1"  :class="{active: currentPage}">
              <a @click="paginate(currentPage)" class="page-link" :class="{'not-clickable': currentPage}">{{currentPage }}</a>
            </li>
            <li class="page-item" v-if="currentPage + 1 <= totalPages">
              <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1}}</a>
            </li>
            <li class="page-item" v-if="currentPage + 2 <= totalPages">
              <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2}}</a>
            </li>
            <li class="page-item" v-if="currentPage + 2 < totalPages">
              <a href="#" class="page-link">...</a>
            </li>
            <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages" :class="{active: totalPages === currentPage}">
              <a @click="paginate(totalPages)" class="page-link" :class="{'not-clickable': totalPages === currentPage}">{{totalPages }}</a>
            </li>
            <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
              <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
</template>


<script>
import axios from 'axios';
import _debounce from "lodash/debounce";
import store from "../../../store";
import Swal from "sweetalert2";
import {
  adminUsersRouteQueriesEqual,
  buildAdminUsersExportParams,
  buildAdminUsersListParams,
  formatAdminUserCountryCell,
  normalizeCountryQueryParam,
  parseAdminUsersRouteQuery,
  serializeAdminUsersRouteQuery,
} from './adminUsersList.mjs';

export default {
  data() {
    return {
      approvedRoles: ['Admin', 'Super Admin'],
      loading: true,
      users: [],
      countries: [],
      keyword: '',
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      perPage: 20,
      registration_date_from: '',
      registration_date_to: '',
      is_news_letter_subscribed: null,
      countryFilter: '',
      role: store.state.auth.user.role,
      disableExport: false,
      _skipUsersQueryWatch: false,
      _usersRequestId: 0,
    }
  },
  mounted() {
    this.hydrateFromRouteQuery(this.$route.query);
    this.fetchCountries();
    this.getUsers();
  },
  watch: {
    '$route.query': {
      deep: true,
      handler() {
        if (this._skipUsersQueryWatch) return;
        this.hydrateFromRouteQuery(this.$route.query);
        this.getUsers();
      },
    },
  },
  methods: {
    formatAdminUserCountryCell,
    formatCountryOptionLabel(c) {
      if (!c || typeof c !== 'object') return '';
      const name = c.name != null ? String(c.name) : '';
      if (name) {
        return name.charAt(0) + name.slice(1).toLowerCase();
      }
      const label = c.label != null ? String(c.label) : (c.Label != null ? String(c.Label) : '');
      return label || String(c.value || '');
    },
    hydrateFromRouteQuery(query) {
      const parsed = parseAdminUsersRouteQuery(query);
      this.keyword = parsed.keyword;
      this.currentPage = parsed.currentPage;
      this.perPage = parsed.perPage;
      this.registration_date_from = parsed.registration_date_from;
      this.registration_date_to = parsed.registration_date_to;
      this.is_news_letter_subscribed = parsed.is_news_letter_subscribed;
      this.countryFilter = parsed.countryFilter;
    },
    isUsersRoute() {
      return this.$route.name === 'Users';
    },
    async syncRouteQuery() {
      if (!this.isUsersRoute()) return;

      const nextQuery = serializeAdminUsersRouteQuery({
        keyword: this.keyword,
        currentPage: this.currentPage,
        perPage: this.perPage,
        registration_date_from: this.registration_date_from,
        registration_date_to: this.registration_date_to,
        is_news_letter_subscribed: this.is_news_letter_subscribed,
        countryFilter: this.countryFilter,
      });
      if (adminUsersRouteQueriesEqual(nextQuery, this.$route.query)) return;
      this._skipUsersQueryWatch = true;
      try {
        await this.$router.replace({ name: 'Users', query: nextQuery });
      } catch (_) {
        /* duplicate navigation */
      }
      await this.$nextTick();
      this._skipUsersQueryWatch = false;
    },
    fetchCountries() {
      axios.get(`/admin/countries`)
        .then((response) => {
          this.countries = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async onCountryFilterChange() {
      this.countryFilter = normalizeCountryQueryParam(this.countryFilter);
      this.currentPage = 1;
      await this.syncRouteQuery();
      this.getUsers();
    },
    debounceGetUsers: _debounce(function () {
      this.loading = true;
      const requestId = ++this._usersRequestId;
      const params = buildAdminUsersListParams({
        page: this.currentPage,
        perPage: this.perPage,
        keyword: this.keyword,
        registration_date_from: this.registration_date_from,
        registration_date_to: this.registration_date_to,
        is_news_letter_subscribed: this.is_news_letter_subscribed,
        countryFilter: this.countryFilter,
      });

      axios.get('/admin/users', { params })
        .then(async (response) => {
          if (requestId !== this._usersRequestId) return;
          if (!this.isUsersRoute()) return;

          this.users = response.data.data;
          this.totalPages = response.data.totalPages;
          this.totalRecords = response.data.totalRecords;
          this.loading = false;
          await this.syncRouteQuery();
        })
        .catch(async (error) => {
          if (requestId !== this._usersRequestId) return;
          if (!this.isUsersRoute()) return;

          this.loading = false;
          console.log(error);
          if (error.response && error.response.status === 422) {
            this.countryFilter = '';
            this.$toast.error('Invalid country filter. It was cleared.');
            await this.syncRouteQuery();
            this.getUsers();
            return;
          }
          this.$toast.error('Failed to load users.');
        });
    }, 500),
    getUsers() {
      this.loading = true;
      this.debounceGetUsers();
    },
    searchKeyword() {
      this.currentPage = 1;
      this.getUsers();
    },
    async perPageFilter(perPage) {
      this.currentPage = 1;
      this.perPage = perPage;
      await this.syncRouteQuery();
      this.getUsers();
    },
    async paginate(page) {
      this.currentPage = page;
      await this.syncRouteQuery();
      this.getUsers();
    },
    async resetFilters() {
      this.keyword = '';
      this.currentPage = 1;
      this.perPage = 20;
      this.registration_date_from = '';
      this.registration_date_to = '';
      this.is_news_letter_subscribed = null;
      this.countryFilter = '';
      await this.syncRouteQuery();
      this.getUsers();
    },

    exportUsers() {
        this.disableExport = true;
        const params = buildAdminUsersExportParams({
          keyword: this.keyword,
          registration_date_from: this.registration_date_from,
          registration_date_to: this.registration_date_to,
          is_news_letter_subscribed: this.is_news_letter_subscribed,
          countryFilter: this.countryFilter,
        });

        axios.get('/admin/export/users', {
          params,
          responseType: 'blob'
        })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' });
          const now = new Date();
          const readableTime = now.toISOString().replace(/[:.]/g, '_').replace('T', '_').split('Z')[0];
          const uniqueFileName = `users_${readableTime}.csv`;
          const link = document.createElement('a');

          link.href = URL.createObjectURL(blob);
          link.download = uniqueFileName;
          link.click();

          URL.revokeObjectURL(link.href);
          this.disableExport = false;
          this.$toast.success('Users exported successfully!');
        })
        .catch(error => {
          console.error('Error downloading file:', error);
          this.$toast.error('Failed to export users. Please try again.');
          this.disableExport = false;
        });
    },

    confirmExport() {
      Swal.fire({
        title: "Do you want to export filtered users ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Export",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          this.exportUsers();
        } else if (result.isDenied) {

        }
      });
    },
  }
}
</script>
